<evc-modal [showReduceButton]="false" (closeModal)="cancel()">
  <div modal-title>
    <div>
      @if (isShowSelectedIcon()) {
        <div class="dialogHeader">
          <mat-icon
            *ngIf="havePermissionOnReport()"
            [matTooltip]="
              isSelectedImage4Report()
                ? ('summaryImageSelect.selectedForReport' | translate)
                : ('summaryImageSelect.notSelectedForReport' | translate)
            "
            matTooltipPosition="below"
            (click)="selectImage4Report(inspectionImage, true); $event.stopPropagation()"
            [color]="isSelectedImage4Report() ? 'accent' : ''"
          >
            description
          </mat-icon>
          <mat-icon
            class="disabled-icon"
            *ngIf="!havePermissionOnReport()"
            [matTooltip]="
              isSelectedImage4Report()
                ? ('summaryImageSelect.selectedForReport' | translate)
                : ('summaryImageSelect.notSelectedForReport' | translate)
            "
            matTooltipPosition="below"
            [ngClass]="{ 'material-icons-outlined': !isSelectedImage4Report() }"
          >
            description
          </mat-icon>
        </div>
      }

      <h3 color="primary" class="dialog-title" [matTooltip]="inspectionImage ? inspectionImage.fileName : null" matTooltipClass="title-tooltip">
        {{ inspectionImage ? inspectionImage.fileName : null }}
      </h3>
    </div>
  </div>

  <div modal-content class="modal-content">
    <div fxLayout="row" class="dialog-nav">
      <nav mat-tab-nav-bar>
        <a mat-tab-link [active]="imageEditMode === 'Data'" [disabled]="isLoadImage" (click)="changeMode('Data')">
          {{ "imageEditDialog.data" | translate }}
        </a>
        <a mat-tab-link [active]="imageEditMode === 'Retouch'" [disabled]="isLoadImage || isVideoContents" (click)="changeMode('Retouch')">
          {{ "imageEditDialog.retouch" | translate }}
        </a>

        @if (merryMeasurementEnabled) {
          <a
            mat-tab-link
            [active]="imageEditMode === 'RemeasurementMerry'"
            (click)="changeMode('RemeasurementMerry')"
            [disabled]="isLoadImage || !isImageMeasurable || isVideoContents"
          >
            {{ "imageEditDialog.remeasurement" | translate }}
          </a>
        } @else {
          <span
            [matTooltip]="isRemeasurementRestrictedOnWeb ? ('imageEditDialog.remeasurementIplexOneWebTooltip' | translate) : null"
            matTooltipPosition="below"
          >
            <a
              mat-tab-link
              [active]="imageEditMode === 'Remeasurement'"
              (click)="changeMode('Remeasurement')"
              [disabled]="isLoadImage || !isImageMeasurable || isVideoContents || isRemeasurementRestrictedOnWeb"
            >
              {{ "imageEditDialog.remeasurement" | translate }}
            </a>
          </span>
        }
        <a mat-tab-link [active]="imageEditMode === 'Property'" [disabled]="isLoadImage || isVideoContents" (click)="changeMode('Property')">
          {{ "imageEditDialog.property" | translate }}
        </a>
      </nav>
    </div>

    <div fxLayout="row" class="dialog-main-content">
      @if (imageEditMode === "Retouch") {
        <app-image-annotation-edit
          class="edit-content"
          [inspectionImage]="inspectionImage"
          [annotationObjects]="annotationObjects"
          [isDataLoaded]="!isLoadImage"
          [isEditable]="isEditable"
          (modified)="modified($event)"
        >
        </app-image-annotation-edit>
      }

      @if (imageEditMode === "Data") {
        <app-image-data-edit
          class="edit-content"
          [inspectionImage]="inspectionImage"
          [inspectionReport]="inspectionReport"
          [isEditable]="isEditable"
          [index]="index"
          [listCount]="imageList.length"
          [subjectModel]="subjectModel"
          [marks]="marks"
          [isPreviewReport]="isPreviewReport"
          [titles]="titles"
          [tags]="tags"
          (changeLocationId)="selectLocationId = $event"
          (changeMarkNum)="selectMarkNum = $event"
          (changeTitle)="title = $event"
          (changeTag)="tag = $event"
          (changeComment)="comment = $event"
          (hasError)="dataHasError = $event"
          (toggleUseModified)="toggleUseModifiedImage($event)"
          (applyMove)="indexChange($event)"
        >
        </app-image-data-edit>
      }

      @if (imageEditMode === "Remeasurement") {
        <app-image-measurement-edit
          class="edit-content"
          [inspectionImage]="inspectionImage"
          [annotationObjects]="annotationObjects"
          [isDataLoaded]="!isLoadImage"
          [isEditable]="isEditable"
          (modified)="modified($event)"
        >
        </app-image-measurement-edit>
      }

      @if (imageEditMode === "Property") {
        <app-image-property-edit
          class="edit-content"
          [inspectionImage]="inspectionImage"
          [index]="index"
          [listCount]="imageList.length"
          [isPreviewReport]="isPreviewReport"
          (applyMove)="indexChange($event)"
        >
        </app-image-property-edit>
      }

      @if (imageEditMode === "VideoData") {
        <app-video-data-edit
          class="edit-content"
          [inspectionImage]="inspectionImage"
          [index]="index"
          [listCount]="imageList.length"
          [isPreviewReport]="isPreviewReport"
          (applyMove)="indexChange($event)"
          (bookMarksHasChanged)="onBookmarksChanged($event)"
        >
        </app-video-data-edit>
      }

      @if (imageEditMode === "RemeasurementMerry") {
        <app-measurement-merry [imageSrc]="originalImagePath" [inspectionImage]="inspectionImage"></app-measurement-merry>
      }
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between center" class="actions" modal-actions>
    <div class="actions__left" fxFlex="25">
      <evc-nav-button
        [type]="buttonTypes.tertiary"
        [size]="buttonSizes.sm"
        [variant]="buttonVariants.semi"
        (click)="delete()"
        [disabled]="!isEditable || isLoadImage"
      >
        {{ "imageEditDialog.delete" | translate }}
      </evc-nav-button>

      @if (imageEditMode === "Remeasurement") {
        <evc-nav-button [type]="buttonTypes.tertiary" [size]="buttonSizes.sm" [variant]="buttonVariants.semi" (click)="resetMeasurementObject()">
          {{ "imageEditDialog.reset" | translate }}
        </evc-nav-button>
      }

      @if (imageEditMode === "Retouch") {
        <evc-nav-button
          [type]="buttonTypes.tertiary"
          [size]="buttonSizes.sm"
          [variant]="buttonVariants.semi"
          [disabled]="isUneditedRetouchImage(modifiedAnnotationObjects)"
          (click)="resetImageAnnotation()"
        >
          {{ "imageEditDialog.reset" | translate }}
        </evc-nav-button>
      }
    </div>

    @if (imageEditMode === "VideoData") {
      <div fxFlex fxLayout="row" fxLayoutAlign="center center">
        <evc-nav-button class="filter-btn" type="secondary" variant="square" leftIcon="plus" size="sm" (click)="addBookmark()">
          {{ "imageEditDialog.addBookMark" | translate }}
        </evc-nav-button>
      </div>
    }

    <div class="actions__right" fxFlex="25" fxLayout="row" fxLayoutAlign="end center">
      @if (imageEditMode !== "Property") {
        <evc-nav-button
          [type]="buttonTypes.primary"
          [size]="buttonSizes.sm"
          [variant]="buttonVariants.semi"
          [disabled]="isApplyDisabled"
          (click)="apply()"
        >
          {{ "imageEditDialog.apply" | translate }}
        </evc-nav-button>
      }
    </div>
  </div>
</evc-modal>
